import { ref, watch } from "vue";
import { usePageScrollService } from "./use-page-scroll-service";

const modalsCounter = ref(0);

const { disablePageScroll, enablePageScroll } = usePageScrollService();

watch(modalsCounter, (newModalsCounter) => {
    if (newModalsCounter < 0) {
        modalsCounter.value = 0;
    }
});

const addToStackedModals = (disableIosScrollLock = false) => {
    modalsCounter.value++;

    if (modalsCounter.value == 1) {
        disablePageScroll(disableIosScrollLock);
    }
};

const removeFromStackedModals = (disableIosScrollLock = false) => {
    modalsCounter.value--;

    if (modalsCounter.value == 0) {
        enablePageScroll(disableIosScrollLock);
    }
};

export function useStackedModals() {
    return {
        addToStackedModals,
        removeFromStackedModals,
    };
}
